module.exports = __webpack_public_path__ + "static/media/pinchi-sole.2f40d033.png";